/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAIPromptAnalyticsAws extends models.GovernanceConfigurationBaseForAIPromptAnalytics {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAIPromptAnalyticsAws");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAIPromptAnalyticsAws.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAIPromptAnalyticsAws>): GovernanceConfigurationForAIPromptAnalyticsAws {
        let obj = Object.assign(new GovernanceConfigurationForAIPromptAnalyticsAws(), model);
        GovernanceConfigurationForAIPromptAnalyticsAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAIPromptAnalyticsAws>): GovernanceConfigurationForAIPromptAnalyticsAws {
        if (!model) return null;
        return GovernanceConfigurationForAIPromptAnalyticsAws.newInstance(<GovernanceConfigurationForAIPromptAnalyticsAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAIPromptAnalyticsAws) {
        if (!obj) return;

        models.GovernanceConfigurationForAIPromptAnalyticsAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAIPromptAnalyticsAws): boolean {
        if (models.GovernanceConfigurationBaseForAIPromptAnalytics.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAIPromptAnalyticsAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Region Id
     */
    region: string;

    /**
     * CloudWatch log group name
     */
    log_group_name: string;

}
